import React from 'react';
import { I18n } from '@aws-amplify/core';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';
import { CustomInputContainer } from '@/components/Settings/DataExtraction/ExtractionType/Model/ExtractionModelDetailsModal/Form/styles';

export function AuthorFormItem() {
	return (
		<FormItemWrapper
			name="author_name"
			label={<LabelMediumRegular>{I18n.get('Author')}</LabelMediumRegular>}
			labelCol={{ span: 24 }}
		>
			<CustomInputContainer disabled={true} />
		</FormItemWrapper>
	);
}
